// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"470871c6","211":"97a2579d","223":"ef33ce7c","308":"55ca89ee","372":"9adef94b","453":"8a33b806","460":"7cd8ad8f","632":"31e071a5","661":"e91a6dc2","673":"bb9acb01","687":"57bde685","832":"cb29dda7","972":"ffaa907f","997":"f06d1539"}[chunkId] + ".chunk.js";
};